import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    OnDestroy,
} from "@angular/core";

import { config as CONFIG } from "app/app.config";
import { DetalleContratistaComponent } from "app/main/apps/mantenedores/contratista/detalle-contratista/detalle-contratista.component";
import { InvitacionesDTO } from "app/main/apps/shared/interfaces/invitacion-trabajo.interface";
import { PersonaDTO } from "app/main/apps/shared/interfaces/persona.interface";

import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";

import { OrdenesDeTrabajoService } from "app/main/apps/shared/services/rest/ordenes-de-trabajo.service";
import { finalize } from "rxjs/operators";
import { Subscription } from "rxjs";
import { TooltipPosition } from "@angular/material/tooltip";
import { UsuarioService } from "app/main/apps/shared/services/rest/usuario.service";

@Component({
    selector: "app-listado-invitaciones-contratistas",
    templateUrl: "./listado-invitaciones-contratistas.component.html",
    styleUrls: ["./listado-invitaciones-contratistas.component.scss"],
})
export class ListadoInvitacionesContratistasComponent
    implements OnInit, OnDestroy
{
    @Input() idOOTT: number;
    @Input() puedeAsignar: boolean;

    @Output()
    asignarContratistaEvent: EventEmitter<{
        contratista: PersonaDTO;
        fcInicio: string;
        fcTermino: string;
    }> = new EventEmitter();
    config;
    invitaciones: InvitacionesDTO[] = [];
    cargandoInvitaciones: boolean;
    subscripciones: Subscription;
    tooltipPosition: TooltipPosition;
    constructor(
        private _oottSrvc: OrdenesDeTrabajoService,
        private _dialogSrvc: DialogService,
        private _usuarioSrvc: UsuarioService
    ) {
        this.tooltipPosition = "above";
        this.config = CONFIG;
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {
        this._oottSrvc.oottsInvitacionesRefresh$.subscribe((resp) => {
            //console.log("paso subcripcion");
            this.getInvitaciones();
        });
    }

    getInvitaciones() {
        this.cargandoInvitaciones = true;
        this.subscripciones.add(
            this._oottSrvc
                .fetchInvitacionTrabajo(this.idOOTT)
                .pipe(finalize(() => (this.cargandoInvitaciones = false)))
                .subscribe((resp) => (this.invitaciones = resp))
        );
    }

    verFichaContratista(rutContratista: number) {
        this._dialogSrvc.abrirDialog(
            DetalleContratistaComponent,
            "clase-dialog",
            "800px",
            rutContratista
        );
    }
    asignarContratista(invitacion: InvitacionesDTO) {
        const data = {
            contratista: invitacion.contratista,
            fcInicio: invitacion.fechaInicioSolicitada,
            fcTermino: invitacion.fechaTerminoSolicitada,
        };
        this.asignarContratistaEvent.emit(data);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
    getFoto(codigoFoto: string) {
        //console.log(codigoFoto);
        this._usuarioSrvc.fetchFoto(codigoFoto).subscribe((blob) => {
            let url = window.URL.createObjectURL(blob);
            //console.log(url);
            //    return this.sanitizer.bypassSecurityTrustUrl(url);
        });
    }
}
